import { useEffect, useState } from "react";
import { Download, Monitor, Smartphone, Apple } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const STEPS = [
  { icon: Monitor, title: "PC Windows / Mac con Chrome o Edge", text: "Clicca l'icona di installazione nella barra degli indirizzi oppure menu ⋮ → \"Installa WhatsApp Business CRM\"." },
  { icon: Apple, title: "Mac con Safari (macOS Sonoma o successivo)", text: "Menu File → \"Aggiungi al Dock\". L'app si apre in una finestra dedicata." },
  { icon: Smartphone, title: "iPhone / iPad (Safari)", text: "Tocca Condividi (quadrato con freccia) → \"Aggiungi alla schermata Home\"." },
  { icon: Smartphone, title: "Android (Chrome)", text: "Menu ⋮ → \"Installa app\" oppure \"Aggiungi a schermata Home\"." },
];

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallApp = () => {
  const [prompt, setPrompt] = useState(() => window.__installPrompt || null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const ready = () => setPrompt(window.__installPrompt);
    const done = () => { window.__installPrompt = null; setPrompt(null); };
    window.addEventListener("installprompt:ready", ready);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("installprompt:ready", ready); window.removeEventListener("appinstalled", done); };
  }, []);
  if (isStandalone()) return null;

  const click = async () => {
    if (!prompt) return setOpen(true);
    prompt.prompt();
    await prompt.userChoice;
    window.__installPrompt = null;
    setPrompt(null);
  };
  return (
    <>
      <button data-testid="install-app-button" onClick={click}
        className="w-full flex items-center justify-center gap-2 text-xs font-semibold py-2 mb-2 rounded-md bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 transition-colors">
        <Download size={14} /> Installa app
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="install-app-dialog" className="max-w-md">
          <DialogHeader>
            <DialogTitle>Installa l'app</DialogTitle>
            <DialogDescription>Usa il CRM come un'app vera: icona sul desktop o sul telefono, finestra dedicata e notifiche.</DialogDescription>
          </DialogHeader>
          <ul className="space-y-3">
            {STEPS.map(({ icon: Icon, title, text }) => (
              <li key={title} className="flex gap-3">
                <span className="w-9 h-9 shrink-0 rounded-lg bg-slate-100 grid place-items-center text-slate-700"><Icon size={16} /></span>
                <div><div className="text-sm font-semibold text-slate-900">{title}</div><div className="text-xs text-slate-500">{text}</div></div>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
};
